module.exports = __webpack_public_path__ + "img/slim.4d75d05d.png";